export const redirectToSsoLogin = (returnPath) => {
  redirectToPPM('/RedirectToSsoLogin.aspx', returnPath)
}

const redirectToPPM = (path, returnPath) => {
  var returnUrl = encodeURIComponent(window.location.origin + returnPath)
  window.location.assign(daptiv.ptb.WebConfig.ppmUrl + `${path}?ReturnUrl=${returnUrl}&loginView=Responsive`)
}



// WEBPACK FOOTER //
// ./src/routes/auth.js